require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./listdropdown"), require("./tags"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./listdropdown", "./tags"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./listdropdown"), require("./tags")) : factory(root["./utils"], root["./listdropdown"], root["./tags"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__36__, __WEBPACK_EXTERNAL_MODULE__52__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[60],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__36__;

/***/ }),

/***/ 39:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/close_16");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(510);


/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _TagInput = _interopRequireDefault(__webpack_require__(511));

exports["default"] = _TagInput["default"];
exports.TagInput = _TagInput["default"];

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _tags = _interopRequireDefault(__webpack_require__(52));

var _listdropdown = _interopRequireDefault(__webpack_require__(36));

var _close_ = _interopRequireDefault(__webpack_require__(39));

var _TagInput = _interopRequireDefault(__webpack_require__(512));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var BaPropTypes = _utils.propsUtils.BaPropTypes;
// Utils
var containsFilter = _utils.arrayFilters.containsFilter;
var getKeyName = _utils.keyboardUtils.getKeyName,
    keyNames = _utils.keyboardUtils.keyNames;
var sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps;
var get = _utils.lodash.get,
    uniqueId = _utils.lodash.uniqueId;

var tagInputClassName = _TagInput["default"].tagInputClassName.replace(/"/g, '');

function filterTags(options, selectedTags) {
  return options.filter(function (option) {
    return selectedTags.every(function (tag) {
      return tag.value !== option.value;
    });
  });
}

var TagInput = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(TagInput, _Component);

  function TagInput(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onClose", function () {
      _this.setState({
        open: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onInputValChange", function (e) {
      var onChange = _this.props.onChange;
      var value = e.target.value;
      var handled = onChange && onChange(value, e);

      if (!handled) {
        _this._updateState(false, value);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_updateState", function (propsUpdated, newInputText) {
      var newState = {};

      if (propsUpdated) {
        newState.selectedTags = _this.props.selectedTags;
        newState.tagOptions = _this.props.tagOptions;
        newState.availTags = typeof _this.props.selectedTags !== 'undefined' ? filterTags(_this.props.tagOptions, _this.props.selectedTags) : _this.props.tagOptions;
        newState.focusedInput = true;
      }

      var open = _this.state.open;
      var inputText = newInputText !== undefined ? newInputText : _this.inputNode.value;
      var _this$props = _this.props,
          tagOptions = _this$props.tagOptions,
          selectedTags = _this$props.selectedTags,
          customFilter = _this$props.customFilter,
          customOpenStateController = _this$props.customOpenStateController;

      var freshOptionSet = _this._refreshOptions(tagOptions, selectedTags);

      var searchResult = customFilter ? customFilter({
        value: inputText,
        values: freshOptionSet
      }) : freshOptionSet.filter(containsFilter(inputText));

      if (customOpenStateController) {
        var customOpen = customOpenStateController({
          value: inputText
        });

        if (customOpen !== open) {
          newState.open = customOpen;
        }

        if (customOpen) {
          newState.availTags = searchResult;
        }
      } else if (!inputText || searchResult.length < 1) {
        if (open) {
          newState.open = false;
        }
      } else if (searchResult.length > 0) {
        newState.availTags = searchResult;

        if (!open) {
          newState.open = true;
        }
      }

      newState.savedLabel = inputText;
      if (Object.entries(newState).length > 0) _this.setState(newState);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onInputKeyDown", function (e) {
      switch (getKeyName(e)) {
        case keyNames.UP:
        case keyNames.DOWN:
        case keyNames.ENTER:
          e.preventDefault();
          _this._dropdown && _this._dropdown._list && _this._dropdown._list.handleKeyEvent(e);

          if (!_this.state.open) {
            var customOpenStateController = _this.props.customOpenStateController;
            var nextOpen = customOpenStateController ? customOpenStateController({
              event: e,
              value: _this.inputNode.value
            }) : true;

            if (nextOpen) {
              _this.setState({
                availTags: filterTags(_this.props.tagOptions, _this.props.selectedTags),
                open: true
              });
            }
          }

          break;

        case keyNames.ESCAPE:
          _this._close();

          break;

        case keyNames.BACKSPACE:
          if (e.target.value === '') {
            var _this$props2 = _this.props,
                onTagRemoved = _this$props2.onTagRemoved,
                onTagsChanged = _this$props2.onTagsChanged;

            var backspaceDelTag = _this.state.selectedTags.pop();

            _this.setState({
              selectedTags: _this.state.selectedTags
            });

            onTagRemoved && onTagRemoved(backspaceDelTag);
            onTagsChanged && onTagsChanged(_this.state.selectedTags);
          }

          break;

        default:
          break;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onBlur", function (e) {
      var listNode = get((0, _assertThisInitialized2["default"])(_this), '_dropdown._list._node');
      var dropdownWrapper = get((0, _assertThisInitialized2["default"])(_this), '_dropdown._wrapper');

      if (listNode && (listNode.contains(document.activeElement) || listNode.contains(e.relatedTarget)) || dropdownWrapper && dropdownWrapper.contains(document.activeElement) || e.target !== e.currentTarget) {
        _this.focus();
      } else {
        _this.blur();

        _this.setState({
          focusedInput: false,
          open: false
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onFocus", function () {
      _this.focus();

      _this._setInputFocused();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_dropdownOnActiveChange", function (focusIndex) {
      _this.setState({
        focusIndex: focusIndex
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setInputFocused", function () {
      _this.setState({
        focusedInput: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_close", function () {
      if (_this.state.open) _this.setState({
        open: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onTagSelect", function (value, name, index) {
      if (_this.state.open) {
        var _this$props3 = _this.props,
            selectionCap = _this$props3.selectionCap,
            onTagAdded = _this$props3.onTagAdded,
            onTagsChanged = _this$props3.onTagsChanged;
        var _this$state = _this.state,
            availTags = _this$state.availTags,
            selectedTags = _this$state.selectedTags;

        if (selectionCap && selectedTags.length >= selectionCap.number) {
          selectionCap.onWarning();
        } else {
          var newSelectedTags = _this.state.selectedTags.concat([availTags[index]]);

          _this.setState({
            selectedTags: newSelectedTags,
            availTags: filterTags(_this.state.tagOptions, selectedTags),
            open: false,
            focusedInput: true,
            savedLabel: ''
          });

          onTagAdded && onTagAdded(availTags[index]);
          onTagsChanged && onTagsChanged(newSelectedTags);
          _this.inputNode.value = '';
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_editLabel", function (tag) {
      if (!_this.props.disabled) {
        // delete the tag
        var _this$props4 = _this.props,
            onTagRemoved = _this$props4.onTagRemoved,
            onTagsChanged = _this$props4.onTagsChanged;
        var _this$state2 = _this.state,
            tagOptions = _this$state2.tagOptions,
            selectedTags = _this$state2.selectedTags;
        var newSelectedTags = selectedTags.filter(function (s) {
          return s.value !== tag.value;
        });

        _this.setState({
          selectedTags: newSelectedTags,
          availTags: filterTags(tagOptions, newSelectedTags),
          // set tag's label to be placed in input box
          savedLabel: tag.label
        });

        onTagRemoved && onTagRemoved(selectedTags.find(function (s) {
          return s.value === tag.value;
        }));
        onTagsChanged && onTagsChanged(newSelectedTags);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_triggerNodeRenderer", function (_ref) {
      var _this$props5 = _this.props,
          id = _this$props5.id,
          hasValidationError = _this$props5.hasValidationError,
          validationErrorText = _this$props5.validationErrorText,
          successText = _this$props5.successText,
          placeholder = _this$props5.placeholder,
          disabled = _this$props5.disabled,
          customWidth = _this$props5.customWidth;
      var _this$state3 = _this.state,
          showFocusClass = _this$state3.showFocusClass,
          focusedInput = _this$state3.focusedInput,
          selectedTags = _this$state3.selectedTags,
          tagActionIcon = _this$state3.tagActionIcon,
          open = _this$state3.open;
      var classes = (0, _utils.classnames)(tagInputClassName, {
        disabled: disabled,
        error: hasValidationError,
        focus: showFocusClass,
        focusedInput: focusedInput,
        open: open,
        success: successText && !hasValidationError,
        tagsSelected: selectedTags.length > 0
      });
      var inputProps = {
        autoComplete: 'off',
        'aria-labelledby': _this._id + "__required-field " + _this._id + "__error-message " + _this._id + "__success-message",
        className: tagInputClassName + "__input",
        disabled: disabled,
        id: id,
        onBlur: _this._onBlur,
        onChange: _this._onInputValChange,
        onFocus: _this._setInputFocused,
        onKeyDown: _this._onInputKeyDown,
        placeholder: selectedTags.length === 0 ? placeholder : '',
        ref: _this._inputRef,
        type: 'text',
        value: _this.state.savedLabel
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes,
        style: {
          width: customWidth
        },
        onClick: _this._onFocus
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "tag-input",
        ref: function ref(node) {
          _this._node = node;
          if (node) _ref(node);
        }
      }, /*#__PURE__*/_react["default"].createElement(_tags["default"], {
        "data-tid": "ba-common-taginput__tags",
        disabled: disabled,
        ref: _this._tagListRef,
        tags: selectedTags,
        tagActionIcon: tagActionIcon,
        editLabel: _this._editLabel
      }, /*#__PURE__*/_react["default"].createElement("input", inputProps)), /*#__PURE__*/_react["default"].createElement("hr", {
        className: tagInputClassName + "__line"
      })), hasValidationError ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "validation-error",
        id: _this._id + "__error-message"
      }, validationErrorText) : /*#__PURE__*/_react["default"].createElement("div", {
        className: "success-message",
        id: _this._id + "__success-message"
      }, successText));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_inputRef", function (node) {
      _this.inputNode = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_tagListRef", function (node) {
      _this._tagList = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_dropdownRef", function (node) {
      _this._dropdown = node;
    });
    var _tagActionIcon = {
      id: _close_["default"].id,
      onClick: _this._deleteTag.bind((0, _assertThisInitialized2["default"])(_this))
    };
    _this.state = {
      availTags: typeof _this.props.selectedTags !== 'undefined' ? filterTags(_this.props.tagOptions, _this.props.selectedTags) : _this.props.tagOptions,
      customWidth: _this.props.customWidth,
      open: false,
      selectedTags: _this.props.selectedTags,
      showFocusClass: false,
      tagActionIcon: _tagActionIcon,
      tagOptions: _this.props.tagOptions,
      warning: false,
      savedLabel: _this.props.value
    };
    _this._id = uniqueId('__tagInput_');
    _this._editLabel = _this._editLabel.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  var _proto = TagInput.prototype;

  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this._close);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this._close);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      // If the value prop changed, update the internal state.
      this._updateState(true, this.props.value);
    } else if (JSON.stringify(this.props.tagOptions) !== JSON.stringify(prevProps.tagOptions) || JSON.stringify(this.props.selectedTags) !== JSON.stringify(prevProps.selectedTags)) {
      // This way of comparing JavaScript arrays is not ideal, but does the job here.
      // A more comprehensive and elegant way would be to *recursively* compare each element by value.
      this._updateState(true);
    } // Max height of tagInput should be 96px as designed.


    if (this._tagList && this._tagList._list.offsetHeight > 96) {
      this._tagList._node.scrollTop = this._tagList._node.scrollHeight - this._tagList._node.clientHeight;
    }
  };

  _proto.blur = function blur() {
    this.inputNode && this.inputNode.blur();
  };

  _proto.focus = function focus() {
    !this.props.disabled && this.inputNode && this.inputNode.focus();
  };

  _proto._refreshOptions = function _refreshOptions(tagOptions, selectedTags) {
    return filterTags(tagOptions, selectedTags);
  };

  _proto._deleteTag = function _deleteTag(e, currentTag) {
    var _this$props6 = this.props,
        onTagRemoved = _this$props6.onTagRemoved,
        onTagsChanged = _this$props6.onTagsChanged;
    var _this$state4 = this.state,
        tagOptions = _this$state4.tagOptions,
        selectedTags = _this$state4.selectedTags;
    var id = currentTag.value;
    var newSelectedTags = selectedTags.filter(function (tag) {
      return tag.value !== id;
    });
    this.setState({
      selectedTags: newSelectedTags,
      availTags: filterTags(tagOptions, newSelectedTags)
    });
    onTagRemoved && onTagRemoved(selectedTags.find(function (tag) {
      return tag.value === id;
    }));
    onTagsChanged && onTagsChanged(newSelectedTags);
  };

  _proto.render = function render() {
    var _this$props7 = this.props,
        className = _this$props7.className,
        customWidth = _this$props7.customWidth,
        size = _this$props7.size,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props7, ["className", "customWidth", "size"]);
    var _this$state5 = this.state,
        availTags = _this$state5.availTags,
        focusIndex = _this$state5.focusIndex,
        open = _this$state5.open;
    var listDropdownPassthroughProps = getInheritedProps(others, _listdropdown["default"]);
    var dropdownProps = (0, _extends2["default"])({}, sanitize(others, TagInput), listDropdownPassthroughProps, {
      customWidth: customWidth,
      focusIndex: focusIndex,
      onActiveChange: this._dropdownOnActiveChange,
      onChange: this._onTagSelect,
      onClose: this._onClose,
      onScrollClose: this._onClose,
      open: open,
      options: availTags,
      ref: this._dropdownRef,
      size: size,
      triggerNodeRenderer: this._triggerNodeRenderer,
      truncated: true
    });
    return /*#__PURE__*/_react["default"].createElement(_listdropdown["default"], (0, _extends2["default"])({
      className: className,
      "data-tid": "ba-common-tag-input__dropdown"
    }, dropdownProps));
  };

  return TagInput;
}(_react.Component);

exports["default"] = TagInput;
(0, _defineProperty2["default"])(TagInput, "propTypes", (0, _extends2["default"])({}, sanitize(_listdropdown["default"].propTypes, null, 'triggerNodeRenderer', 'options'), {
  /** Classname to be given to the container of TagInput */
  className: _propTypes["default"].string,

  /** Value of the input field */
  value: _propTypes["default"].string,

  /** Custom filtering function */
  customFilter: _propTypes["default"].func,

  /** Custom function to control the open state of the dropdown */
  customOpenStateController: _propTypes["default"].func,

  /** Width set */
  customWidth: _propTypes["default"].string,

  /** Disable tag input */
  disabled: _propTypes["default"].bool,

  /** To show validation error state */
  hasValidationError: _propTypes["default"].bool,

  /** ID for input of TagInput */
  id: _propTypes["default"].string,

  /** Function that is called when a tag is added and return the added tag */
  onTagAdded: _propTypes["default"].func,

  /** Function that is called when value is typed into input field */
  onChange: _propTypes["default"].func,

  /** Function that is called when a tag is removed and return the removed tag */
  onTagRemoved: _propTypes["default"].func,

  /** Function that is called when a selected tag array is changed and return the selected tags array */
  onTagsChanged: _propTypes["default"].func,

  /** Placeholder text */
  placeholder: _propTypes["default"].string,

  /** Choose between one of the two fixed sizes */
  size: _propTypes["default"].oneOf(['normal', 'small']),

  /** To show validation success message */
  successText: _propTypes["default"].string,

  /** Selected tags to show in the input box, with designated colors for preset */
  selectedTags: _propTypes["default"].array,

  /** Number key is for the maximum number of tags a user can select and onWarning is a callback function when a user tries to go over the limit. */
  selectionCap: _propTypes["default"].object,

  /** Tag options where a user select tags from, , with designated colors for preset */
  tagOptions: _propTypes["default"].array,

  /** To show validation error message */
  validationErrorText: _propTypes["default"].string,

  /** Accepted on the Tags control but ignored on the TagInput control because it doesn't work. */
  maxTagWidth: BaPropTypes.deprecated('is ignored because it doesn\'t work.')
}));
(0, _defineProperty2["default"])(TagInput, "defaultProps", {
  className: '',
  customWidth: '100%',
  disabled: false,
  selectedTags: [],
  size: 'normal',
  tagOptions: [],
  value: ''
});

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(513);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-tagInput{display:inline-block;width:100%;-ms-overflow-style:none}.ba-common-tagInput .tag-input{background-color:rgba(0,0,0,0.05);border:0;border-bottom-width:2px;border-bottom-style:solid;position:relative}.ba-common-tagInput.is-disabled>.ba-common-tagInput.is-disabled__input{cursor:not-allowed}.ba-common-tagInput.is-disabled *{cursor:not-allowed}.ba-common-tagInput.is-tagsSelected .ba-common-tagInput__input{margin-left:0}.ba-common-tagInput.is-focusedInput .ba-common-tagInput__input::-ms-clear{display:none}.ba-common-tagInput .ba-common-tags{min-height:32px;max-height:96px;overflow-y:auto;padding:4px 16px 4px 16px}.ba-common-tagInput__input{width:100px;flex-grow:1;border:0;outline:none;font-family:inherit;font-size:.875rem;background-color:transparent;position:relative;margin:2px 0;padding:4px;display:inline-block;line-height:21px}.ba-common-tagInput__input:active{cursor:none}.ba-common-tagInput__placeholder{width:max-content;opacity:0.6}.ba-common-tagInput__line{position:absolute;display:block;width:100%;transform:scaleX(0);border-width:0;border-bottom-width:2px;border-style:solid;bottom:-2px;margin:0}.ba-common-tagInput__icon{position:absolute;line-height:0;pointer-events:none;z-index:1}.ba-common-tagInput__icon.is-left{top:20px;left:16px;transform:translateX(-50%) translateY(-50%)}.ba-common-tagInput__icon.is-right{bottom:0;right:16px;transform:translateX(50%) translateY(-50%)}.ba-common-tagInput .more-info{position:absolute;top:-24px;right:1px;font-size:.75rem;font-weight:600;visibility:hidden;cursor:pointer}.ba-common-tagInput .success-message{visibility:hidden;font-size:.75rem;font-weight:600;margin-top:8px;color:#24a148;color:hsla(var(--support-02-h, 137.28), var(--support-02-s, 63.45178%), var(--support-02-l, 38.62745%), 1);position:relative}.ba-common-tagInput .validation-error{visibility:hidden;font-size:.75rem;font-weight:600;margin-top:8px;color:#da1e28;color:hsla(var(--support-01-h, 356.80851), var(--support-01-s, 75.80645%), var(--support-01-l, 48.62745%), 1);position:relative}.ba-common-tagInput .is-validation{visibility:visible}.ba-common-tagInput .is-moreInfo{visibility:visible}.ba--highContrast .ba-common-tagInput.is-disabled{cursor:not-allowed}.ba--highContrast .ba-common-tagInput.is-disabled:after{content:'';position:absolute;top:50%;left:0;width:100%;border-bottom:1px solid currentColor}.ba-common-tagInput{transition:opacity .2s ease-in-out;transition:color .2s ease-in-out,border-color .2s ease-in-out;color:#343334;border-color:#595859}.ba-common-tagInput.is-error .tag-input{border-color:#da1e28;border-color:hsla(var(--support-01-h, 356.80851), var(--support-01-s, 75.80645%), var(--support-01-l, 48.62745%), 1)}.ba-common-tagInput.is-error .validation-error{visibility:visible}.ba-common-tagInput.is-success .tag-input{border-color:#00aa5e;border-color:hsla(var(--communication1-h, 153.17647), var(--communication1-s, 100%), var(--communication1-l, 33.33333%), 1)}.ba-common-tagInput.is-success .success-message{visibility:visible}.ba-common-tagInput::placeholder{transition:color .2s ease-in-out;color:#595859}.ba-common-tagInput__line{transition:transform .2s ease-in-out;border-color:#0f62fe;border-color:hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1)}.ba-common-tagInput__createNewTagItem{color:#0f62fe;color:hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1)}.ba-common-tagInput.is-open .ba-common-tagInput__icon,.ba-common-tagInput.is-focusedInput .ba-common-tagInput__icon{color:#0f62fe;color:hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1)}.ba-common-tagInput.is-open .ba-common-tagInput__line,.ba-common-tagInput.is-focusedInput .ba-common-tagInput__line{transform:scaleX(1)}.ba-common-tagInput__icon{transition:color .2s ease-in-out;color:#595859}.ba-common-tagInput.is-disabled .tag-input{opacity:.5}.ba-common-tagInput.is-focus{box-shadow:0px 0px 0px 2px #a8c0f3;box-shadow:0px 0px 0px 2px var(--focus, #a8c0f3)}.ba-common-tagInput.is-focus>.ba-common-tagInput__input:focus:enabled ~ .ba-common-tagInput__line{border-color:#595859}.ba-common-tagInput .more-info{color:#0f62fe;color:hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1)}.ba-common-tagInput.is-disabled .ba-common-button{opacity:1}.ba-common-tagInput.is-disabled .ba-common-button .ba-common-button__layout{opacity:.5}\n", ""]);

// exports
exports.locals = {
	"tagInputClassName": "\"ba-common-tagInput\""
};

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__52__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[509,0]]]);
});